import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import UserLayout from '../../components/user/UserLayout';
import FileUploader from '../../components/FileUploader';
import DocumentList from '../../components/DocumentList';
import api from '../../lib/api';
import { useToast } from '../../components/common/ToastProvider';

export default function UserTrainingPage() {
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('');
  const [previewText, setPreviewText] = useState('');
  const [previewing, setPreviewing] = useState(false);
  const [saving, setSaving] = useState(false);
  const { showToast } = useToast();

  const previewUrl = async () => {
    if (!url.trim()) {
      showToast('Enter a URL first.', 'warning');
      return;
    }
    try {
      setPreviewing(true);
      const { data } = await api.post('/admin/train-url/preview/', { url: url.trim() });
      setPreviewText(data?.text || '');
      showToast(`Preview complete (${data?.page_count || 0} page(s))`, 'success');
    } catch (e) {
      showToast(e?.response?.data?.error || 'Failed to preview URL content.', 'danger');
    } finally {
      setPreviewing(false);
    }
  };

  const saveUrlTraining = async () => {
    if (!previewText.trim()) {
      showToast('Preview URL content before saving.', 'warning');
      return;
    }
    try {
      setSaving(true);
      const payload = {
        url: url.trim(),
        title: title.trim() || 'Trained from URL',
        text: previewText,
      };
      const { data } = await api.post('/admin/train-url/save/', payload);
      showToast(data?.message || 'URL training saved.', 'success');
      setPreviewText('');
      setUrl('');
      setTitle('');
    } catch (e) {
      showToast(e?.response?.data?.error || 'Failed to save URL training.', 'danger');
    } finally {
      setSaving(false);
    }
  };

  return (
    <UserLayout
      title="Training Data"
      subtitle="Upload and manage the files used to train your AI"
    >
      <Row className="g-4">
        <Col lg={5}>
          <Card className="user-card p-4 h-100">
            <div className="user-section-title">Upload Files</div>
            <FileUploader />
          </Card>
        </Col>

        <Col lg={7}>
          <Card className="user-card p-4 h-100">
            <div className="user-section-title">Uploaded Documents</div>
            <DocumentList />
          </Card>
        </Col>
      </Row>

      <Row className="g-4 mt-1">
        <Col lg={12}>
          <Card className="user-card p-4">
            <div className="user-section-title">Train via URL</div>
            <Row className="g-3">
              <Col md={8}>
                <Form.Control
                  placeholder="https://example.com/docs"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  placeholder="Training title (optional)"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Col>
              <Col md={12}>
                <div className="d-flex gap-2 flex-wrap">
                  <Button onClick={previewUrl} disabled={previewing || !url.trim()}>
                    {previewing ? 'Previewing...' : 'Preview URL'}
                  </Button>
                  <Button variant="success" onClick={saveUrlTraining} disabled={saving || !previewText.trim()}>
                    {saving ? 'Saving...' : 'Save URL Training'}
                  </Button>
                </div>
              </Col>
              <Col md={12}>
                <Form.Control
                  as="textarea"
                  rows={10}
                  value={previewText}
                  onChange={(e) => setPreviewText(e.target.value)}
                  placeholder="URL preview content will appear here."
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </UserLayout>
  );
}
